import axios from 'axios'
const axiosClient = axios.create({
	baseURL: 'https://ldlawyer.dgss.vn:8800/api',
}
)
export default axiosClient;